<template>
    <div class="view view__module_edit">
        <module-edit/>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>
import ModuleEdit from '@/components/ebs/modules/edit/ModuleEdit'
import PopNotify from '@/components/default/shared/PopNotify'
import { allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect } from '@/helpers/mixins'

export default {
  name: 'view-module-edit',
  components: { PopNotify, ModuleEdit },
  mixins: [allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect],
  methods: {
    getModule () {
      const moduleID = this.$route.params.id
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('ebsModuleGetSCORM', moduleID).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    }
  },
  created () {
    this.getModule()
    this.$eventBus.$on('module-submit', this.allowRedirect)
  },
  beforeDestroy () {
    this.$eventBus.$off('module-submit')
  }
}
</script>
